export default "__VITE_ASSET__147250f5__"